import { render, staticRenderFns } from "./JeecgOrderTicketList.vue?vue&type=template&id=fad6d042&scoped=true&"
import script from "./JeecgOrderTicketList.vue?vue&type=script&lang=js&"
export * from "./JeecgOrderTicketList.vue?vue&type=script&lang=js&"
import style0 from "./JeecgOrderTicketList.vue?vue&type=style&index=0&id=fad6d042&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fad6d042",
  null
  
)

export default component.exports